import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { FontsService, Font } from '../../../services/fonts.service';
import { AuthService } from '../../../services/auth.service';

@Component({
	selector: 'app-weather',
	templateUrl: './weather.component.html',
	styleUrls: ['./weather.component.scss']
})
export class WeatherComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('weatherForm', { static: true }) weatherForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	weatherFormSubscription: Subscription;
	background_type;
	maxDate;
	newapi = false;
	maxDaysAllowed = 15;
	isAdmin;
	fonts: Array<Font>;
	font = '';
	customFont = '';
	customFontString = 'Custom Font';

	constructor(private comService: ComponentService, private fontsService: FontsService, private auth: AuthService) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();

		if (this.componentData.config.version >= 2 && this.componentData.config.newapi) {
			this.newapi = true;
		}

		this.maxDate = new Date();
		this.maxDate.setDate(new Date().getDate() + (this.maxDaysAllowed - this.componentData.config.num_of_days));

		this.fonts = this.fontsService.getFonts();
		let defaultFont = this.fonts.find((font) => font.label === 'Arial');
		if (typeof this.componentData.config.base === 'undefined') {
			this.font = defaultFont.url;
			this.componentData.config.base = { text: { font: defaultFont.url } };
		}
		const fontConfig = this.fonts.find((obj) => obj.url === this.componentData.config.base.text.font);

		if (fontConfig === undefined) {
			if (this.componentData.config.base.text.font) {
				this.font = this.customFontString;
				this.customFont = this.componentData.config.base.text.font;
			}
		} else {
			this.font = fontConfig === undefined ? 'Arial.ttf' : fontConfig.url;
		}

		this.componentData.config.language = this.componentData.config.language ? this.componentData.config.language : 'english';

		this.background_type = this.componentData.config.background['background-image'] ? 'Image' : 'Color';
		this.weatherFormSubscription = this.weatherForm.valueChanges
			.pipe(
				tap(() => {
					this.comService.updateDisabledSave(
						(this.weatherForm.dirty && this.weatherForm.invalid) || this.nameField.editComponentName
					);
				}),
				filter((form) => this.weatherForm.dirty && this.weatherForm.valid),
				debounceTime(2000)
			)
			.subscribe();
	}

	ngOnDestroy() {
		if (this.weatherFormSubscription) {
			this.weatherFormSubscription.unsubscribe();
		}
	}

	brodcastToPreview() {
		if (this.weatherForm.valid) {
			if (this.font !== this.customFontString || this.customFont !== this.customFontString) {
				this.comService.updateComponentData(this.componentData);
				this.comService.updatePreviewData();
			}
		}
	}

	resetBackground(type) {
		if (type == 'color') {
			this.componentData.config.background['base-background-image'] = this.componentData.config.background['background-image'];
			this.componentData.config.background['background-image'] = '';
		} else {
			this.componentData.config.background['background-image'] = this.componentData.config.background['base-background-image'];
		}
	}

	onImageChange(event: any): void {
		this.componentData.config.background['background-image'] = String(event && event.url);
		this.componentData.config.background['width'] = Number(
			event && event.width ? event.width : this.componentData.config.background['width']
		);
		this.componentData.config.background['height'] = Number(
			event && event.height ? event.height : this.componentData.config.background['height']
		);
	}

	onChange(selectedValue) {
		this.font = selectedValue;
		this.componentData.config.base.text.font = selectedValue;
		if (selectedValue === this.customFontString) {
			this.customFont = this.customFontString;
		}
		this.comService.updateDisabledSave(this.font === this.customFontString && this.customFont === this.customFontString);
	}

	onCustomFontSelect($event) {
		this.componentData.config.base.text.font = $event.url;
		this.customFont = $event.url;
		if (this.customFont !== this.customFontString) {
			this.comService.updateDisabledSave(false);
		}
	}

	onAddressChange(event, location) {
		const cords = event.lat + ',' + event.lng;
		this.componentData.config.cords = cords;
		this.componentData.config.location = event.address;
	}

	hide(elm) {
		setTimeout(() => {
			elm.hide();
		});
	}

	changeDayCount(event) {
		if (this.newapi) {
			let newMax = new Date();
			newMax.setDate(new Date().getDate() + (this.maxDaysAllowed - parseInt(event)));
			this.maxDate = newMax;
		}
	}
}
